<template>
    <div class="page-title-container">
        <div
            @click="onBack"
            class="back"
        >
            <v-icon name="back" />
            <span class="desc">{{ channelType === 1 ? '小程序插件' : '网页会话' }}</span>
        </div>
        <div class="title-box">
            <h3 class="title">
                {{ title }}
            </h3>
            <v-tip
                ref="defaultTplTip"
                placement="top"
                kind="small"
            >
                <div class="default-tpl-tip">
                    <p>新建的接待组件自动应用默认模板，如需个性化样式，</p>
                    <p>可创建窗口形象模板并选择应用的位置。</p>
                </div>
            </v-tip>
            <v-icon
                v-if="isDefaultTpl"
                v-tip:defaultTplTip.hover
                :style="{ width: '24px', height: '24px' }"
                name="basic_help_line_temp"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    inject: ['channelType'],
    props: {
        isCreate: {
            type: Boolean,
            default: false,
        },
        isDefaultTpl: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        title() {
            if (this.isDefaultTpl) {
                return '默认模板';
            }

            return `${this.isCreate ? '新建' : '编辑'}会话窗口与形象`;
        },
    },
    methods: {
        onBack() {
            const tab = this.channelType === 1 ? 'miniPlugin' : 'web';
            this.$router.push({ name: 'ChatWindow', query: { tab }});
        },
    },
};
</script>

<style lang="less" scoped>
.default-tpl-tip {
    padding: 8px;
    color: var(--text-color-text-primary, rgba(0, 1, 11, 0.93));
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.page-title-container {
    padding: 16px 0;

    .back {
        display: flex;
        width: max-content;
        align-items: center;
        cursor: pointer;

        svg {
            width: 12px;
            height: 12px;
            color: rgba(0, 11, 52, 0.41);
        }

        .desc {
            margin-left: 4px;
            color: var(--text-color-text-caption, rgba(0, 11, 52, 0.41));
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 142.857% */
        }
    }

    .title-box {
        margin-top: 10px;
        display: flex;
        align-items: center;

        .title {
            color: var(--text-color-text-primary, rgba(0, 1, 11, 0.93));
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 28px; /* 140% */
        }

        svg {
            margin-left: 10px;
            width: 24px;
            height: 24px;
            color: rgba(1, 11, 50, 0.41);
        }
    }
}
</style>
